import { createApp } from 'vue';
import App from '../App.vue';
import store from './state';
import router from '@/routes';
import VueSweetalert2 from 'vue-sweetalert2'
import { MaskInput } from "vue-mask-next";
import { setupGlobalErrorHandler } from '@/utils/errorHandler';

import 'bootstrap';
import 'bootstrap-icons/font/bootstrap-icons.css';

import '@/assets/scss/_custom.scss';
import '@/assets/scss/style.scss';
import '@/assets/scss/main.scss';
import 'sweetalert2/dist/sweetalert2.min.css'

const app = createApp(App);
app.component('mask-input', MaskInput);

setupGlobalErrorHandler(app);

app
    .use(store)
    .use(VueSweetalert2)
    .use(router)
    .mount('#app');
